// extracted by mini-css-extract-plugin
module.exports = {"reviewsContainer":"az_Ecd","customReviewsContainer":"az_Fcd","reviews":"az_Gcd"};